<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import TestimonialsTable from './TestimonialsTable';


export default {
  page: {
    title: 'Testimonials',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, TestimonialsTable },
  data() {
    return {
      title: 'Testimonials',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Testimonials', active: true, },
      ],

      loading: true,
      filters: {
        whereins: {
          website: [],
        },
      },
    }
  },
  created() {
    this.filters.whereins.website = [this.website_id];
  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <TestimonialsTable ref="TestimonialsTable" :changefilters="filters"  @loadchange="(e) => {loading = e;}"></TestimonialsTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


